import type { TypedDocumentNode } from "@graphql-typed-document-node/core";

import { gql } from "urql";

interface BatchClaimsVariables {
  includes: string;
  userBasedFilter: Record<string, unknown>;
}

export interface BatchClaimsResult {
  batchClaims?: {
    nodes: { id: string; icn?: string | null }[];
  };
}

export const batchClaimsQueryDoc: TypedDocumentNode<
  BatchClaimsResult,
  BatchClaimsVariables
> = gql`
  query batchClaims($includes: String!, $userBasedFilter: BatchClaimFilter!) {
    batchClaims(
      filter: {
        and: [$userBasedFilter, { icn: { includesInsensitive: $includes } }]
      }
    ) {
      nodes {
        id
        icn
      }
    }
  }
`;
